// Screen reader summary for slider and tiles
export function generateSrSummaryFromItem(item) {
    if (!item) return '';
    let srSummary = `Kacheltitel: ${item.title || ''}, Text auf der Grafik:`;

    function interpretPosition(x, y, width, height) {
        let pos = '';
        if (height) {
            if (y < height / 3) pos += 'oben';
            else if (y > 2 * height / 3) pos += 'unten';
            else pos += 'mittig';
        } else {
            if (y < 33) pos += ', oben';
            else if (y > 66) pos += ', unten';
            else pos += 'mittig';
        }
        if (width) {
            if (x < width / 3) pos += ' links';
            else if (x > 2 * width / 3) pos += ' rechts';
            else pos += ' zentriert';
        } else {
            if (x < 33) pos += ' links';
            else if (x > 66) pos += ' rechts';
            else pos += ' zentriert';
        }
        return pos;
    }

    if (item.rows && item.rows.length) {
        item.rows.forEach(row => {
            let pos = interpretPosition(row.x, row.y, item.x, item.y);
            srSummary += `-${pos}: ${row.title};`;
        });
    }

    if (item.price && (item.price.value || item.price.euro)) {
        let pricePos = interpretPosition(item.price.x, item.price.y, item.x, item.y);
        let prefix = item.price.prefix ? item.price.prefix : '';
        let value = item.price.value || (item.price.euro ? `${item.price.euro},${item.price.cent}` : '');
        srSummary += `-${pricePos}: Verkaufspreis: ${prefix}${value}€;`;
    }
    if (item.button && item.button.text) {
        let buttonPos = interpretPosition(item.button.x, item.button.y, item.x, item.y);
        srSummary += `${buttonPos}: Button: ${item.button.text}`;
    }
    return srSummary;
}